'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { useParams, useSearchParams } from 'next/navigation';
import Navbar from '../../../../components/Navbar';
import Footer from '../../../../components/Footer';
import PropertyCard from '../../../../components/PropertyCard';
import { api } from '@/lib/apiClient';
import InterestedPopup from '../../../../components/InterestedPopup';
import PropertyGallery from '../../../../components/PropertyGallery';
import Cookies from 'js-cookie';
const BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api/proxy/';

function convertToArray(str) {
    if (!str) return [];
    return str.split('-').map(num => parseInt(num, 10));
}

const tabs = ['Overview', 'Amenities', 'Location'];

export default function PropertyDetailPage() {
    const params = useParams();
    const propertyId = params.id;
    //const property = mockPropertyDetails[propertyId] || defaultProperty;

    const [activeTab, setActiveTab] = useState('Overview');
    const [isSaved, setIsSaved] = useState(false);

    const [similarProperties, setSimilarProperties] = useState([]);
    const [property, setProperty] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showInterestedPopup, setShowInterestedPopup] = useState(false);
    const [isLoggedInContext, setIsLoggedInContext] = useState(false);
    const searchParams = useSearchParams();
    const cityId = searchParams.get("cityId");
    const [searchData, setSearchData] = useState("");
    const [userId, setUserId] = useState("");
    const [localities, setLocalities] = useState("");
    const [dynamicAdBanners, setDynamicAdBanners] = useState([]);


    useEffect(() => {
        fetchProperty();
        fetchAds();
    }, [propertyId]);

    const fetchAds = async () => {
        try {
            const adsRes = await api.post('selectwithout/ad_listing_det', { sqlData: '*', where: 'is_live=$1', whereData: [true] });
            if (adsRes.success === 1 && Array.isArray(adsRes.data)) {
                let validAds = adsRes.data.filter(ad => {
                    if (!ad.view_places) return false;
                    try {
                        let vp = typeof ad.view_places === 'string' ? JSON.parse(ad.view_places) : ad.view_places;
                        if (Array.isArray(vp)) return vp.includes('sell');
                        return typeof ad.view_places === 'string' && ad.view_places.toLowerCase().includes('sell');
                    } catch (e) {
                        return typeof ad.view_places === 'string' && ad.view_places.toLowerCase().includes('sell');
                    }
                });

                validAds.sort(() => 0.5 - Math.random());
                validAds = validAds.slice(0, 2);

                if (validAds.length === 0) return;

                const listingIds = validAds.filter(a => a.listing_id).map(a => a.listing_id);
                const projectIds = validAds.filter(a => a.project_id).map(a => a.project_id);

                let listingsMap = {};
                let projectsMap = {};

                if (listingIds.length > 0) {
                    const listingPromises = listingIds.map(id =>
                        api.post('selectwithout/listings', { sqlData: 'id,featured_image_url,listing_type,property_sub_type', where: 'id=$1', whereData: [id] })
                    );
                    const resArray = await Promise.all(listingPromises);
                    resArray.forEach(res => {
                        if (res.success === 1 && Array.isArray(res.data)) {
                            res.data.forEach(l => listingsMap[l.id] = l);
                        }
                    });
                }
                if (projectIds.length > 0) {
                    const projectPromises = projectIds.map(id =>
                        api.post('selectwithout/projects', { sqlData: 'id,featured_image_url', where: 'id=$1', whereData: [id] })
                    );
                    const resArray = await Promise.all(projectPromises);
                    resArray.forEach(res => {
                        if (res.success === 1 && Array.isArray(res.data)) {
                            res.data.forEach(p => projectsMap[p.id] = p);
                        }
                    });
                }

                const mappedAds = await Promise.all(validAds.map(async (ad) => {
                    let image = '/no-image.jpeg';
                    let link = '#';
                    let isExternal = false;

                    if (ad.listing_id && listingsMap[ad.listing_id]) {
                        const l = listingsMap[ad.listing_id];
                        if (l.featured_image_url) image = BASE_URL + l.featured_image_url;
                        if (l.property_sub_type != 6 && l.listing_type == "sell") {
                            link = `/property/${l.id}`;
                        } else {
                            link = `/rent/p/${l.id}`;
                        }
                    } else if (ad.project_id && projectsMap[ad.project_id]) {
                        const p = projectsMap[ad.project_id];
                        if (p.featured_image_url) image = BASE_URL + p.featured_image_url;
                        link = `/projects/p/${ad.project_id}`;
                        isExternal = true;
                    }

                    try {
                        const currentViews = ad.views || 0;
                        await api.post(`updatewithout/ad_listing_det/${ad.id}`, { views: currentViews + 1 }, { skipAuthGuard: true });

                    } catch (e) {
                        console.error("Error updating views", e);
                    }

                    return {
                        id: ad.id,
                        title: ad.ad_head || 'Advertisement',
                        description: ad.short_desc || '',
                        image: image,
                        ctaText: 'View Details',
                        link: link,
                        isExternal: isExternal,
                        rawAd: ad
                    };
                }));

                setDynamicAdBanners(mappedAds);
            }
        } catch (e) {
            console.error('Error fetching ads', e);
        }
    };

    const fetchProperty = async () => {
        const user = await Cookies.get('id');
        if (user) {
            await setUserId(user.replace(/^"|"$/g, ''));
            setIsLoggedInContext(true);
            console.log("user", user);
        }
        const localitiesArray = convertToArray(searchParams.get("localities"));
        setLocalities(localitiesArray);
        let whereClause = "listing_type=$1 and city_id=$2";
        let whereData = [1, cityId];
        try {
            const res = await api.post('selectwithout/view_home_listing_details', {
                sqlData: "*",
                where: "id=$1",
                whereData: [propertyId],
            }, { skipAuthGuard: true });
            if (res.success === 1 && Array.isArray(res.data)) {
                const fetchedProperty = res.data[0].property_view;
                setProperty(fetchedProperty);
                const propertySubType = res.data[0].property_sub_type;
                const bhk = res.data[0].bedrooms;
                const price = res.data[0].price;
                if (localitiesArray.length > 0) {
                    whereClause += " and locality_id in ($3)";
                    whereData.push(localitiesArray.join(","));
                    whereClause += " and property_type=$4 and bedrooms<=$5 and price<=$6 and id!=$7 order by created_at desc limit 3";
                    whereData.push(propertySubType, bhk, price, propertyId);
                }
                else {
                    whereClause += " and property_type=$3 and bedrooms<=$4 and price<=$5 and id!=$6 order by created_at desc limit 3";
                    whereData.push(propertySubType, bhk, price, propertyId);
                }
                var sData = "listingType=" + fetchedProperty?.listingType + "&title=" + fetchedProperty?.title + "&city_id=" + cityId + "&listing_type=1" + "&localities=" + localitiesArray.join(",") + "&property_type=" + propertySubType + "&bedrooms=" + bhk + "&price=" + price + "&id=" + propertyId;
                setSearchData(sData);
                const response = await api.post('selectwithout/view_home_listings',
                    {
                        sqlData: "*",
                        where: whereClause,
                        whereData: whereData,
                    }, { skipAuthGuard: true });
                console.log("response.data", response.data);
                let property_card = [];
                for (let i = 0; i < response.data.length; i++) {
                    property_card.push(response.data[i].property_card);
                }
                setSimilarProperties(property_card);
                // Update views count for all visitors (not just logged-in users)
                const currentViews = res.data[0].property_view?.views_count || 0;
                await api.post('updatewithout/listings/' + propertyId, { views_count: currentViews + 1 }, { skipAuthGuard: true });

            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = () => {
        setIsSaved(!isSaved);
        // API call to save/unsave property
    };

    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: property?.title,
                url: window.location.href,
            });
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert('Link copied to clipboard!');
        }
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                </div>
                <Footer />
            </>
        );
    }

    if (!property || Object.keys(property).length === 0) {
        return (
            <>
                <Navbar />
                <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Property Not Found</h2>
                    <p className="text-gray-500 mb-4">The property you are looking for does not exist or has been removed.</p>
                    <Link href="/buy" className="btn btn-primary">Return to Properties</Link>
                </div>
                <Footer />
            </>
        );
    }

    const specs = [
        { label: 'Property Type', value: property.type },
        { label: 'Bedrooms', value: `${property.bedrooms} BHK` },
        { label: 'Bathrooms', value: property.bathrooms },
        { label: 'Balconies', value: property.balconies },
        { label: 'Floor', value: property.floor },
        { label: 'Facing', value: property.facing },
        { label: 'Age', value: property.propertyAge },
        { label: 'Furnishing', value: property.furnishing },
        { label: 'Parking', value: property.parking },
        { label: 'Built-up Area', value: `${property.area} ${property.areaUnit}` },
        { label: 'Carpet Area', value: `${property.carpetArea} ${property.areaUnit}` },
    ];

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-gray-50">
                {/* Breadcrumb */}
                <div className="bg-white py-4">
                    <div className="container-custom">
                        <nav className="flex items-center gap-2 text-sm text-gray-500">
                            <Link href="/" className="hover:text-primary">Home</Link>
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                            <Link href="/buy" className="hover:text-primary">Buy</Link>
                            {property.city && (
                                <>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    <Link href={`/buy/${property.city.toLowerCase()}`} className="hover:text-primary">{property.city}</Link>
                                </>
                            )}
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                            <span className="text-gray-900 truncate max-w-[200px]">{property.title}</span>
                        </nav>
                    </div>
                </div>

                <div className="container-custom">
                    <div className="grid lg:grid-cols-3 gap-8 py-4 items-start">
                        {/* Main Content */}
                        <div className="lg:col-span-2">
                            {/* Image Gallery */}
                            <PropertyGallery
                                images={property.images}
                                baseUrl={BASE_URL}
                                title={property.title}
                            />

                            {/* Property Header */}
                            <div className="bg-white rounded-xl p-6 mb-6">
                                <div className="flex flex-wrap gap-2 mb-3">
                                    {property.badges?.map((badge, idx) => (
                                        <span key={idx} className="badge badge-success">{badge}</span>
                                    ))}
                                </div>

                                <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
                                    {property.title}
                                </h1>

                                <p className="flex items-center gap-2 text-gray-600 mb-4">
                                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    {property.address}
                                </p>

                                <div className="flex flex-wrap items-center gap-6 py-4 border-y border-gray-200">
                                    <div>
                                        <span className="text-3xl font-bold text-gray-900">
                                            ₹{property.price} {property.priceUnit}
                                        </span>
                                        <span className="text-gray-500 ml-2">
                                            @ ₹{property.pricePerSqft}/{property.areaUnit}
                                        </span>
                                    </div>
                                    <div className="flex gap-3 ml-auto">
                                        <button
                                            onClick={handleSave}
                                            className={`btn ${isSaved ? 'btn-primary' : 'btn-secondary'}`}
                                        >
                                            <svg className="w-5 h-5" fill={isSaved ? 'currentColor' : 'none'} viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                            </svg>
                                            {isSaved ? 'Saved' : 'Save'}
                                        </button>
                                        <button onClick={handleShare} className="btn btn-secondary">
                                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                                            </svg>
                                            Share
                                        </button>
                                    </div>
                                </div>

                                {/* Quick Specs */}
                                <div className="flex flex-wrap gap-6 mt-4">
                                    <div className="flex items-center gap-2">
                                        <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                        </svg>
                                        <span className="text-gray-700">{property.bedrooms} BHK</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                                        </svg>
                                        <span className="text-gray-700">{property.area} {property.areaUnit}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                        </svg>
                                        <span className="text-gray-700">{property.floor}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Tabs */}
                            <div className="bg-white rounded-xl overflow-hidden">
                                <div className="detail-tabs">
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab}
                                            onClick={() => setActiveTab(tab)}
                                            className={`tab ${activeTab === tab ? 'active' : ''}`}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>

                                <div className="p-6">
                                    {activeTab === 'Overview' && (
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Description</h3>
                                            <p className="text-gray-600 leading-relaxed mb-6">{property.description}</p>

                                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Property Details</h3>
                                            <div className="detail-specs">
                                                {specs.map((spec, idx) => (
                                                    <div key={idx} className="spec-item">
                                                        <span className="label">{spec.label}</span>
                                                        <span className="value">{spec.value}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'Amenities' && (
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Amenities</h3>
                                            <div className="amenities-grid">
                                                {property.amenities?.map((amenity, idx) => (
                                                    <div key={idx} className="amenity-item">
                                                        <div className="icon">
                                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                            </svg>
                                                        </div>
                                                        <span>{amenity}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'Location' && (
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Location</h3>
                                            <p className="text-gray-600 mb-4">{property.address}</p>
                                            <div className="aspect-video bg-gray-100 rounded-xl flex items-center justify-center">
                                                <div className="text-center text-gray-500">
                                                    <svg className="w-12 h-12 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    </svg>
                                                    <p>Map integration will be added</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Similar Properties */}
                            <div className="mt-10">
                                <h2 className="text-xl font-bold text-gray-900 mb-6">Similar Properties</h2>
                                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {similarProperties.map((prop) => (
                                        <PropertyCard key={prop.id} property={prop} />
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Sidebar - Contact Card */}
                        <aside className="lg:col-span-1 space-y-6 lg:sticky lg:top-24">
                            {/* Rental Summary Card */}
                            <div className="bg-white rounded-2xl shadow-lg border border-primary/20 p-6 relative overflow-hidden">
                                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-purple-600"></div>

                                <h4 className="font-bold text-gray-900 mb-4 text-sm uppercase"> Posted by</h4>
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="w-10 h-10 bg-gradient-to-br from-gray-700 to-gray-900 rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md">
                                        {property.agent?.name?.charAt(0) || '?'}
                                    </div>
                                    <div>
                                        <h5 className="font-bold text-gray-900">{property.agent?.name}</h5>
                                        <p className="text-xs text-gray-500">{property.agent?.role ? 'Owner' : 'Agent'}</p>
                                    </div>
                                </div>
                                <div className="flex justify-between items-end mb-6">
                                    <div>
                                        <p className="text-gray-500 text-sm font-medium uppercase"> Total Cost </p>
                                        <h3 className="text-2xl font-bold text-gray-900">
                                            ₹{property.price} {property.priceUnit}
                                        </h3>
                                    </div>
                                    <div className="text-right">
                                        <span className="text-sm text-gray-500 block"> Per Sqft </span>
                                        <span className="font-semibold text-gray-800">
                                            @ ₹{property.pricePerSqft} </span>
                                    </div>
                                </div>

                                <button onClick={() => { setShowInterestedPopup(true); }} className="w-full btn btn-primary py-3.5 text-base font-bold shadow-primary/30 shadow-md mb-4">
                                    I'm Interested
                                </button>

                                <div className="pt-4 border-t border-gray-100 flex items-center justify-center gap-2 text-xs text-gray-400">
                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                                    Your details are safe with us
                                </div>
                            </div>

                            {/** AD BLOCK */}

                            {/* Ad Banners */}
                            {dynamicAdBanners.map((ad) => (
                                <AdBanner
                                    key={ad.id}
                                    {...ad}
                                    onClick={() => handleAdClick(ad)}
                                />
                            ))}
                        </aside>
                    </div>
                </div>


            </main>
            <InterestedPopup
                isOpen={showInterestedPopup}
                onClose={() => setShowInterestedPopup(false)}
                loggedInPerson={isLoggedInContext}
                listingId={propertyId}
                mode="listing"
                phone={property.agent?.phone}
                agentName={property.agent?.name}
                searchData={searchData}
            />
            <Footer />
        </>
    );
}
